import { render, staticRenderFns } from "./IconWaitConfirm.vue?vue&type=template&id=d8ef3ed2&"
import script from "./IconWaitConfirm.vue?vue&type=script&lang=js&"
export * from "./IconWaitConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports